import SafeTrans from '../../i18n/SafeTrans';
import { useTranslation } from 'react-i18next';
import './HeroBanner.css';

export interface HeroBannerProps {
  title?: string;
  skillCount?: number;
}

export default function HeroBanner({
  title,
  skillCount = 200,
}: HeroBannerProps) {
  const { t } = useTranslation('skills');
  return (
    <section className="hero-banner">
      <div className="hero-banner__text">
        <h1 className="hero-banner__title">{title ?? t('hero.title')}</h1>
        <p className="hero-banner__subtitle">
          <SafeTrans
            t={t}
            i18nKey="hero.count"
            values={{ n: skillCount }}
            components={{ highlight: <span className="hero-banner__highlight" /> }}
          />
        </p>
      </div>
      <div className="hero-banner__characters">
        <img
          src="/images/SkillMarketplace-Banner.png"
          alt={t('hero.imageAlt')}
          className="hero-banner__banner-img"
        />
      </div>
    </section>
  );
}
